import styles from './Contact.module.scss';

import ComercialForms from '../../components/ComercialForms/ComercialForms';
import { useRef, useState } from 'react';
import SacForms from '../../components/SacForms/SacForms';
import { motion, AnimatePresence } from 'framer-motion';

const Contact = () => {
    const [selectedForm, setSelectedForm] = useState<string | undefined>('');
    const comercialRef = useRef<HTMLDivElement>(null);
    const sacRef = useRef<HTMLDivElement>(null);
    const ouvidoriaRef = useRef<HTMLDivElement>(null);

    const forms = {
        comercial: <ComercialForms />,
        sac: <SacForms typeForm={selectedForm} />,
        ouvidoria: <SacForms typeForm={selectedForm} />,
    };

    const handleSelectForm = (formChoice: string | undefined) => {
        setSelectedForm(formChoice?.toLowerCase());
    };

    const setSelectedClass = (formChoice: string | undefined) => {
        return formChoice?.toLowerCase() === selectedForm && styles.selected;
    };

    const renderForms = () => {
        return forms[selectedForm as keyof typeof forms];
    };

    return (
        <>
            <section className={styles.form_container}>
                <div className={styles.form_title}>
                    <h2>Fale conosco</h2>
                </div>

                <section className={styles.form_choice}>
                    <div
                        ref={comercialRef}
                        className={`${styles.form_choice_box} ${setSelectedClass(comercialRef.current?.innerHTML)}`}
                        onClick={() => handleSelectForm(comercialRef.current?.innerHTML)}
                    >
                        Comercial
                    </div>
                    <div
                        ref={sacRef}
                        className={`${styles.form_choice_box} ${setSelectedClass(sacRef.current?.innerHTML)}`}
                        onClick={() => handleSelectForm(sacRef.current?.innerHTML)}
                    >
                        SAC
                    </div>
                    <div
                        ref={ouvidoriaRef}
                        className={`${styles.form_choice_box} ${setSelectedClass(ouvidoriaRef.current?.innerHTML)}`}
                        onClick={() => handleSelectForm(ouvidoriaRef.current?.innerHTML)}
                    >
                        Ouvidoria
                    </div>
                </section>

                <section className={styles.content_forms}>
                    <section
                        className={`${styles.content_box}  ${Boolean(selectedForm) ? styles.custom_content : ''}`}
                    >
                        <div className={styles.content}>
                            <h2>Decatron</h2>
                            <p>
                                Há três décadas em uma trajetória de sucesso e crescimento saudável,
                                a Decatron tem atuado em todo o território nacional, desenvolvendo
                                projetos e soluções, implementando, gerindo e otimizando processos
                                de TI.
                            </p>
                        </div>

                        <div className={styles.content}>
                            <h3>Localização</h3>
                            <p>Estrada dos Bandeirantes, 7000 - Jacarepagua, Rio de Janeiro - RJ</p>
                        </div>
                    </section>
                    <AnimatePresence mode="wait">
                        <motion.div
                            className={`${styles.forms} ${styles.show_forms}`}
                            key={selectedForm}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.2 }}
                        >
                            {selectedForm && <h3>Formulário {selectedForm}</h3>}
                            {renderForms()}
                        </motion.div>
                    </AnimatePresence>
                </section>
            </section>
        </>
    );
};

export default Contact;
